export default __webpack_public_path__ + "static/media/alcoholic-1.d079b2a1.png";